const styles = ({ palette }) => ({
  word: {
    whiteSpace: "nowrap",
    display: "inline-block",
  },
});

export default styles;
